<template>
  <div>
    <v-layout row wrap justify-center>
      <ui-title-red textTitle="Efectividad"></ui-title-red>
    </v-layout>
    <v-layout row wrap justify-center class="adorn-top-right" pt-5>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Efectividad'" videoEmbed="ADMINISTRACIONDINERO12Efectividad (ant43).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm4 text-xs-center class="animated fadeInLeft adorn-bottom-left">
        <image-app :imaSize="400" imaSrc="contenido/diapositiva_12" imaAlt="Cuatro engranajes funcionando"></image-app>
      </v-flex>
      <v-flex xs12 sm2 text-xs-center hidden-xs-only class="animated fadeInLeft dura_1">
        <image-app :imaSize="120" imaSrc="design/red-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm5 class="animated fadeInUp dura_1 ">
        <p>
          Para
          <strong>mejorar</strong> nuestra
          <strong>efectividad</strong> en la administración del dinero, vamos a conocer algunos conceptos clave como:
          <strong>ingresos, gastos, presupuesto y patrimonio.</strong><br><br> También vamos a obtener algunas herramientas muy útiles y sencillas que nos van a ayudar a seguir consolidando nuestro
          <strong>futuro financiero</strong>.
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-12.vue?a8393b52